<template>
    <client-page>
        <template #subHead>
            <sub-visual sh="태성 이혼가사변호사" tabActive="태성 이혼가사변호팀 소개" bg="/images/sub/visual/sv-about.jpg" />
        </template>
        <page-section tit="태성의 이혼 변호인단" titAdd="법무법인 태성" class="page-section--center">
            <v-divider />
            <div v-for="item in product" :key="item.title">
                <card-row :image="item.image" :title="item.title" :txt="item.txt" class="py-30px py-md-60px" />
                <v-divider />
            </div>
        </page-section>
        <page-section tit="이혼전문변호사란?" titAdd="대한변호사협회 등록" gridSectionBg="/images/sub/taesung/center/center-bg2.jpg" gridSectionRightBg="/images/sub/taesung/center/center-bg2-mo.jpg">
            <div slot="gridSectionRight">
                <txt class="white--text line-height-17"> 이혼전문변호사란 대한변호사협회 전문분야 심사위원회에서 당해변호사의 처리 이혼사건의 수, 관련논문, 학위, 강의, 외부 할동 경험등을 종합적으로 검토하여 등록을 마친 경우에만 사용할 수 있는 명칭입니다. 이러한 심사없이 이혼전문변호사라는 단어를 쓰게 되는 경우에는 대한변호사협회의 징계 대상이 됩니다. </txt>
                <span class="line my-10px my-md-16px"></span>
                <tit class="tit--sm white--text">
                    이혼전문변호사는 의뢰인의 사건을 유연하게 살펴보고 <br />
                    <span class="primary--text">합리적인 솔루션을 전해드릴 수 있습니다.</span>
                </tit>
            </div>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/sets/styles/apps/client-page.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/sets/styles/pages/page-section.vue";
import CardRow from "@/sets/styles/card-row.vue";

import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        CardRow,

        Tit,
        Txt,
    },
    data: () => {
        return {
            product: [
                {
                    // title: "전문성",
                    txt: "<strong>이혼 사건만 14년, <br /> 이혼 가사 사건  7,500건 이상의 상담 경험 <br />1사건 2인 변호사 체제 <br />이혼팀 변호사 전원은 오직 이혼, 가사 사건만 담당</strong>",
                    image: "/images/sub/taesung/center/center-img.jpg",
                },
                {
                    title: "언론의 신뢰, 다양한 방송출연 및 자문",
                    image: "/images/sub/taesung/center/center-img2.jpg",
                },
                {
                    title: "황혼이혼 재산분할 성공사례 보유",
                    image: "/images/sub/taesung/center/center-img3.jpg",
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.page-section--center {
    background-image: url(/images/sub/taesung/center/center-bg.svg);
    background-size: auto 100%;
    background-position: right bottom;
}
</style>
